import {
  LOAD_START,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  EDIT_START,
  EDIT_SUCCESS,
  EDIT_FAILURE,
  ADD_START,
  ADD_SUCCESS,
  ADD_FAILURE,
  SAVE_START,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  DELETE_START,
  DELETE_SUCCESS,
  DELETE_FAILURE,
  CORP_NP_LOADED
} from './actions';

const initialState = {
  loading: false,
  users: [],
  pagination: {},
  user: null,
  nonprofits: [],
  corporations: [],
  saving: false,
  deleting: false
};

export default (state = {}, action) => {
  let newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case LOAD_START:
      newState.loading = true;
      newState.users = [];
      newState.pagination = {};
      break;
    case LOAD_SUCCESS:
      newState.loading = false;
      newState.users = action.payload.data;
      newState.pagination = action.payload.pagination;
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      break;
    case EDIT_START:
      newState.loading = true;
      break;
    case EDIT_SUCCESS:
      newState.loading = false;
      newState.user = action.payload.data;
      newState.user.userEmail = newState.user.username;

      if (action.payload.corporations) {
        newState.corporations = action.payload.corporations;
      }

      if (action.payload.nonprofits) {
        newState.nonprofits = action.payload.nonprofits;
      }
      break;
    case EDIT_FAILURE:
      newState.loading = false;
      break;
    case ADD_START:
      newState.saving = true;
      break;
    case ADD_SUCCESS:
      newState.saving = false;
      break;
    case ADD_FAILURE:
      newState.saving = false;
      break;
    case SAVE_START:
      newState.saving = true;
      break;
    case SAVE_SUCCESS:
      newState.saving = false;
      break;
    case SAVE_FAILURE:
      newState.saving = false;
      break;
    case DELETE_START:
      newState.deleting = true;
      break;
    case DELETE_SUCCESS:
    case DELETE_FAILURE:
      newState.deleting = false;
      break;
    case CORP_NP_LOADED:
      if (action.payload.corporations) {
        newState.corporations = action.payload.corporations;
      }

      if (action.payload.nonprofits) {
        newState.nonprofits = action.payload.nonprofits;
      }
      break;
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/users/reducer.js